var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13453_9890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15V4.16666C0 2.32833 1.495 0.833328 3.33333 0.833328H5C5.38667 0.833328 5.77333 0.924162 6.11833 1.09666L8.7475 2.41166C8.8625 2.46916 8.99167 2.49916 9.12 2.49916H13.3333C15.6308 2.49916 17.5 4.36833 17.5 6.66583H8.35333C6.155 6.66583 4.18417 8.13749 3.55833 10.2517L1.33083 18.0342C0.516667 17.2733 0 16.1992 0 15ZM19.5775 9.18083C19.1783 8.64499 18.57 8.33749 17.9042 8.32666C17.8917 8.32666 17.8817 8.33333 17.8692 8.33333H8.35333C6.88833 8.33333 5.57417 9.31416 5.15833 10.7183L2.81 18.9208C3.2375 19.0692 3.68917 19.1667 4.16667 19.1667H14.6317C16.4867 19.1667 18.09 17.9733 18.6333 16.1608L19.91 11.0642C20.105 10.4125 19.9833 9.72666 19.5775 9.18083Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13453_9890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyReports);
export default __webpack_public_path__ + "static/media/my-reports.ace0a5dcbf92a70a9a2c8d24b2742988.svg";
export { ForwardRef as ReactComponent };